import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  TableContainer,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Paper,
  ListItem,
} from "@material-ui/core";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import CancelIcon from "@material-ui/icons/Cancel";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";

import NavBar from "../../../Component/NavBar/AdminHeader/AdminHeader";
import Axios from "axios";
import CustomDialog from "../../../Component/DialogBox/CustomDialog";
import { url } from "../../../config/config";
import { adminLogout } from "../../../redux/action/action";
import CustomTableHead from "../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../Component/Table/CutomTableFooter/CustomTableFooter";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./Feedback.css";
import AdminPageTitle from "../../../Component/AdminPageTitle/AdminPageTitle";
import FeedbackFilter from "./FeedbackFilter/FeedbackFilter";

class ViewFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        date: "",
      },
      page: 0,
      rowsPerPage: 5,
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Email Address",
        },
        {
          name: "Message",
        },
        {
          name: "Messaged Date",
        },
        {
          name: "Action",
        },
      ],
      feedBackdata: [],
      dialogOpen: false,
      isEmpty: false,
      feedbackIdToDelete: "",
      notificationOpen: false,
      sessionExpired: false,
      detailStatus: false,
      detailData: {},
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const response = await Axios.get(`${url}/api/feedbacks`);
      if (response.data.length !== 0) {
        this.setState({
          feedBackdata: response.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          feedBackdata: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  handleSearch = (e) => {
    this.setState({ search: { date: e.target.value } });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleDeleteFeedback = async () => {
    let response = await Axios.delete(
      `${url}/api/feedbacks/${this.state.feedbackIdToDelete}`
    );
    if (response.data.success) {
      this.handleDialogClose();
      this.handleNotificationOpen();
      this.getData();
    }
  };

  handleCancelDetail = () => {
    this.setState({ detailStatus: false });
  };

  handleDetailFeedback = (detailData) => {
    this.setState({ detailStatus: true, detailData });
    // this.props.history.push(`/_administration_/feedback/detail/${feedBackId}`);
  };

  handleDialogOpen = (feedbackId) => {
    this.setState({
      dialogOpen: true,
      feedbackIdToDelete: feedbackId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    const filtered = this.state.feedBackdata.filter((feedback) => {
      return feedback.createdAt.indexOf(this.state.search.date) !== -1;
    });
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogut()} />
          )}
          <AdminPageTitle title="Feedbacks" refreshUrl={this.props.match.url} />
          <Divider />
          <br />

          <FeedbackFilter
            data={this.state.search}
            handleChange={this.handleSearch}
          />
          <br />

          <div>
            {this.state.feedBackdata.length !== 0 ? (
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={this.state.detailStatus ? 8 : 12}
                  xl={this.state.detailStatus ? 8 : 12}
                  lg={this.state.detailStatus ? 8 : 12}
                >
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />
                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                          : filtered
                        ).map((user, index) => (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: `${
                                index % 2 ? "#eee" : "white"
                              }`,
                            }}
                          >
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{user.email}</TableCell>
                            <TableCell align="center">
                              {user.message.substring(0, 10) + "..."}
                            </TableCell>
                            <TableCell align="center">
                              {user.createdAt}
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip
                                arrow
                                title="Delete"
                                className={classes.tooltip}
                                onClick={() => this.handleDialogOpen(user._id)}
                              >
                                <DeleteIcon />
                              </Tooltip>
                              <Tooltip
                                arrow
                                title="view feedback"
                                className={classes.tooltip}
                                onClick={() => this.handleDetailFeedback(user)}
                              >
                                <InfoIcon />
                              </Tooltip>
                              <CustomDialog
                                open={this.state.dialogOpen}
                                handleClose={this.handleDialogClose}
                                handleDelete={this.handleDeleteFeedback}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <CustomTableFooter
                        count={filtered.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                    {this.showNotification(classes.notificationStyle)}
                  </TableContainer>
                </Grid>

                {this.state.detailStatus && (
                  <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
                    <Paper className={classes.paper}>
                      <div style={{ display: "flex" }}>
                        <b style={{ flexGrow: 1 }}>Feedback Details</b>
                        <Tooltip
                          arrow
                          title="Close"
                          className={classes.tooltip}
                          onClick={() => this.handleCancelDetail()}
                        >
                          <CancelIcon />
                        </Tooltip>
                      </div>
                      <div>
                        <ListItem divider>
                          <b style={{ flexGrow: 1 }}>Email</b>
                          {this.state.detailData.email}
                        </ListItem>
                        <div style={{ textAlign: "center", padding: 5 }}>
                          {this.state.detailData.message}
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            ) : this.state.isEmpty === true ? (
              <CustomEmptyMessage message="There is no any data present in the database." />
            ) : (
              <CustomLoader />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewFeedback)));
